import React from 'react';
import Header from './Header';
import Input from './Input';
import PasswordInput from './PasswordInput';
import { useNavigate } from 'react-router-dom';
import { useConfirm } from './ConfirmContext';

import { ReactComponent as Spinner } from './images/spinner.svg';

const Login = () => {
  let navigate = useNavigate();
  let confirm = useConfirm();

  let [email, setEmail] = React.useState('');
  let [password, setPassword] = React.useState('');
  let [loading, setLoading] = React.useState(false);

  const handleLogin = () => {
    setLoading(true);

    fetch(process.env.REACT_APP_SERVER_URL + '/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: email.trim(),
                             password: password.trim() })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          localStorage.setItem('token', data.token);

          if (email.trim() === 'automation@polygraph.net') {
            localStorage.setItem('limited', true);
            navigate('/dashboard/automation-results');
          }
          else {
            localStorage.setItem('limited', false);
            navigate('/dashboard/recent-traffic');
          }
        } else {
          const f = async () => {
            await confirm(data.message, true);
            setEmail('');
            setPassword('');
            setLoading(false);
          };

          f();
        }
      })
      .catch(error => console.error('Error:', error));
  };

  return (
    <>
      <Header />
      <form onSubmit={e => {
              e.preventDefault();
              handleLogin()
            }}>
        <div style={{width: '30%',
                     display: 'flex',
                     flexDirection: 'column',
                     justifyContent: 'center',
                     alignItems: 'center',
                     backgroundColor: 'black',
                     borderRadius: '5px',
                     color: 'white',
                     gap: '20px',
                     padding: '20px',
                     position: 'absolute',
                     top: '50%',
                     left: '50%',
                     transform: 'translate(-50%, -50%)',
                    }}>
          <Input type="text"
                 placeholder="Username"
                 value={email}
                 onChange={(e) => setEmail(e.target.value)} />

          <PasswordInput type="password"
                         placeholder="Password"
                         value={password}
                         hideWarning={true}
                         onChange={(e) => setPassword(e.target.value)} />

          <div style={{display: 'flex',
                       width: '100%',
                       justifyContent: 'center',
                      }}>
            <button style={{padding: '15px 120px',
                            backgroundColor: 'white',
                            color: 'black',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            fontFamily: 'inherit',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                           }}>
              <span>Log In</span>
              {loading && (
                <Spinner style={{
                           margin: '0 auto',
                           width: '20px',
                           height: '20px',
                           animation: 'spin 1s linear infinite',
                         }} />
              )}
            </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default Login;
